<!doctype html>
<html>

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1">
    <title>ACTION NEEDED! Payment request</title>
    <style type="text/css">
        @import url('https://fonts.googleapis.com/css?family=Roboto:400,100,300,500,700,900');
    </style>
</head>

<body
    style="background-color:#fff; margin-top: 50px; margin-bottom: 0; padding-top: 0; padding-bottom: 0; width: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;"
    offset="0" topmargin="0" leftmargin="0">
    <table border="0" cellpadding="0" cellspacing="0"
        style="background-color:#f5f5f5; border:1px solid #ddd;border-bottom:none;font-family: 'Roboto', sans-serif;width: 640px;margin: 0 auto;font-size: 13px;">
        <tr>

            <td colspan="3" style="height:4px;"></td>
        </tr>
        <tr>
            <td width="15px"></td>
            <td>
                <img src="../../../assets/images/final automated.png" style="border:none" width="130" height="60"
                    alt="Loanlogic" title="Loanlogic" />
            </td>

            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
        </tr>
        <tr>
            <td colspan="3" style="height:2px;"></td>
        </tr>
    </table>
    <table
        style="background-color:#fff; font-family: 'Roboto', sans-serif;width: 640px;margin: 0 auto;font-size: 13px;border-left:1px solid #ddd;border-right:1px solid #ddd;"
        border="0" cellpadding="0" cellspacing="0">
        <tr>
            <td colspan="3" style="height:30px;"></td>
        </tr>
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td style="font-size:16px;">Dear Infovision Mortgage Borrower,</td>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
        </tr>

        <tr>
            <td colspan="3" style="height:5px;"></td>
        </tr>
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td style="font-size:15px;">
                <br />
                <p>To use your credit card, debit / check card to pay your &quot;Appraisal Fee&quot; for
                    your loan with Infovision Mortgage, please click the following link:
                <p>&nbsp;&nbsp;&nbsp;&nbsp;<a href=" https://www.paypal.com/us/webapps/mpp/payflow-payment-gateway ">PAY
                        NOW</a></p>



            </td>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
        </tr>


        <!-- <tr>
            <td colspan="3" height="50"></td>
        </tr> -->
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td>Thank you for selecting Infovision as your mortgage loan provider.<br /><br />Appraisal Fee Services
                <br />AFSOpssupport@infovision.com
            </td>
            <td width="15px"></td>
        </tr>
        <!-- <tr>
            <td colspan="3" height="10"></td>
        </tr> -->
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td>
                <!-- <img src="https://ng.afstest.com/uiportal/assets/img/icons/brands/InfoVision_logo.png" style="border:none" width="50" height="50"  alt="logo" title="Logo" /> -->
            </td>
            <td width="15px"></td>
        </tr>
        <tr>
            <td colspan="3" style="height:20px;"></td>
        </tr>
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td style="font-size: 11px;"> CONFIDENTIALITY: This is a system generated email may contain confidential
                information and any unauthorized </td>
            <td width="15px"></td>
        </tr>
        <tr>
            <td width="15px">&nbsp;&nbsp;&nbsp;</td>
            <td style="font-size: 11px;">Disclosure or use of this is prohibited. Please do not reply this email. </td>
            <td width="15px"></td>
        </tr>
        <tr>
            <td colspan="3" style="height:20px;"></td>
        </tr>
    </table>
    <table
        style="background-color:#fff; font-family: 'Roboto', sans-serif;width: 640px;margin: 0 auto;font-size: 13px;border:1px solid #ddd;border-top:1px dashed #ccc;"
         cellpadding="0" cellspacing="0">
        <tr>
            <td style="padding: 20px;">
                    <b>Disclaimer:</b> <br>
                    To protect the privacy of certain individuals the names and identifying details have been
                    changed." "This is a work of fiction. Any names or characters, businesses or places, events or
                    incidents, are fictitious. Any resemblance to actual persons, living or dead, or actual events is
                    purely coincidental."
            </td>

        </tr>
        <tr>
            <!-- <td style="text-align:center;font-weight:500;color:#888;width: 145px;">© 2023 - Powered by</td>
            <td style="text-align:left;font-weight:500;color:#888;padding-bottom: 20px;"><img
                    src="https://ng.afstest.com/uiportal/assets/img/icons/brands/InfoVision_logo.png"
                    style="border:none" width="60" height="70" alt="logo" title="Logo" /></td> -->

            <footer>
                <div class="text-center">
                    © {{ currentYear }} - Powered by <img src="../../../assets/images/InfoVision_logo.png" alt="Logo"
                        class="login-logo">
                </div>
            </footer>
        </tr>
    </table>
</body>

</html>